export default {
  "Navbar": "2qYNA99b2EI2MYosu8wceO",
  "HomePage": "44eCROQUqkUqOI0Wus0S2Q",
  "Ancestry": "DDwY7OKPg48OEGEaCSYqy",
  "Ancestry Tree": "13p1I2Ti8OACeCc6O4iW0i",
  "Breed Tests": "nyiWblUhCo2G0o6qSis0s",
  "Breeds": "3OiTX2kmm4ow2yCSW0MiSm",
  "Mixed Breed Groups": "5KLZg84F5CMOwgIgYUMggq",
  "Breed Group Mappings": "611bcIW9Dak4IICEKMI60M",
  "Breeds Analyzed": "5bYOzV3LN6OeIUAm4ceCei",
  "Certificate": "76I7hELemWiUkkuOakKiMi",
  "Health": "3AbUuyPp4cqE0oCK0YIeOW",
  "At Risk": "6YFZmcpRokGa2YIIUsOuU2",
  "Carrier": "4jh6enNSZiIWyyQC6MwaWG",
  "All Clear": "6Mh5EfBQPusiiw8qM8g6a0",
  "No Call": "1LC9HdSIi0ocaaqis28MKy",
  "Multidrug Sensitivity": "1lsPJLbeNaIwA8Wa0CsoCe",
  "Traits": "5V6RjsO252AiKe0kAQc0YM",
  "Exercise Induced Collapse": "6GTTMVG2T6YecEAKSiwMAg",
  "Adult Weight": "6ruWyupC7YaE8MaEI888ym",
  "Community": "2RhMmTw2FayUISWQIq0628",
  "Learn More": "1LscpKCAisMGGCeGuSYEEE",
  "Notes": "4L9cpL4sNqEAKIw2GKS0aG",
  "The Science": "2hsJFF1pAgAOSyIwsiusYc",
  "Our Technology": "1oS6m46Yfy8WEUs0wSe2Kc",
  "Inheritance": "53eIuFYFZK8W4Cg6YYwAeO",
  "FAQs": "7pByoRRQ76igSCsUYeYgwA",
  "LearnMoreTraits": "1URIzGqqMQqQoW6KkyYyMG",
  "Glossary": "5IUHxDSDT2ASMIwIGkgMis",
  "Upgrade" : "1AEABd1g7eiw4E4kQq0qq2",
  "Affenpinscher": "vuoMIrUbniiwWWaqiUqKA",
  "Afghan Hound": "4XsrnthDJeGgkMiIA4QAeY",
  "Airedale Terrier": "yByiPUurqoEcYyYki0aAi",
  "Akita": "6Df1f0zxBeAGKcq0u2W0Qy",
  "Alaskan Klee Kai": "4MWRkckmowiyea0E6AOQCC",
  "Alaskan Malamute": "6AwkVJMosE8YGEsaAom4sm",
  "American English Coonhound": "1orPFNk22gaGYqYgUsaqK2",
  "American Eskimo Dog": "1Ztji7RhWAWImUS688Mq00",
  "American Foxhound": "6VRwrPSQfYgwmKyA0e2e8i",
  "American Hairless Rat Terrier": "1lIz5RS66sikSgaqgYSmoo",
  "American Staffordshire Terrier": "NwGtmgLSuq2aiWYIgiwwu",
  "American Water Spaniel": "8VEqFlKx1u28UUQW2I0sO",
  "Australian Cattle Dog": "72IReaOp1uAWcE6EAAKeE8",
  "Argentine Dogo": "1X4KCeJJ5WQUScIiqsgAM0",
  "Australian Kelpie": "44k9QFzM2k8KMcecCkWeM4",
  "Australian Shepherd": "6AqTIuwKswWUsGesIAqyig",
  "Australian Terrier": "e1ra8OEoJUwWY0y00iQOc",
  "Anatolian Shepherd Dog": "401PSrDe9iCCQ8I6OWImcQ",
  "Azawakh": "5JmeMLRLSEcGU2Okqoguks",
  "Basenji": "7gAt4tlkJ22Y8sGiQowcQu",
  "Basset Griffon Vendeen (Grand)": "4NYds6zBTi046Cy4WyAoG8",
  "Basset Griffon Vendeen (Petit)": "2YIJTAfEOkKE0guYsOsGyo",
  "Basset Hound": "41I88ViZDiSs6G6Eeey2ui",
  "Barbet": "4TPFO1qqmAUwKsS222yMk4",
  "Beagle": "10VGs1YohMYc24A6sWI2cm",
  "Bearded Collie": "3oJfEsMLeMsaS6ygs8a84Q",
  "Beauceron": "4dsIwTafCMW6MswSmiwEqY",
  "Bedlington Terrier": "2S9y5axS8EeOIoAYSsOmmW",
  "Belgian Sheepdog": "4NNU5byoowscouIEc0KKSC",
  "Belgian Malinois": "4DfQx2jTQcmUEIMw4YymWG",
  "Belgian Tervuren": "1XrPReoE8YoowgwmKkAgSC",
  "Bergamasco": "67jXNmPx8QEamAE02miSea",
  "Bernese Mountain Dog": "2JSoPsRZziO2ckea4eiWE6",
  "Berger Picard": "3bc74WRcAw4UiQ0qSAeUyu",
  "Bichon Frise": "49QCcf0NEcCse4ck2ga08A",
  "Biewer Terrier": "5YmBgAdeGAUgee4UsAIMce",
  "Black Russian Terrier": "rEf7WsOKsgaWe0yeISO0a",
  "Bloodhound": "6jD1z4ib168a8SemKyQ22Q",
  "Blue Tick Coonhound": "1z9Vy7a3i0gqWs66CakkKi",
  "Boerboel": "1PL8ngVySswSqwIWoQSW8U",
  "Bolognese": "2gIa7a6yIwYcoCGoImciSg",
  "Border Collie": "49PRyJjaOcgiAcO4acM6qi",
  "Border Terrier": "74Pa3jc4oMSmc6K8ywmeY4",
  "Borzoi": "243GoDJQeksOSgIGQEsCY4",
  "Boston Terrier": "2lysFdY8DCgeaQqoMOK8yo",
  "Bouvier Des Flanders": "1OglMRofEAYCE8mGkAE4EI",
  "Boxer": "3qIvqwBygwYKMm4OouaQSe",
  "Boykin Spaniel": "r7yklhfuKGokoO0cQMkUE",
  "Briard": "52yaCxwxL2G6EEskwwSS0I",
  "Brittany": "7FEDu21X1Y4EsAqGKWwiIw",
  "Brussels Griffon": "6yqFRl0c0gyoA0O0KkeoQa",
  "Bull Terrier": "735Ctd9gxq4KcG46GI66WM",
  "Bull Terrier (Miniature)": "IqSVExr4QuMIu2MkAGcEe",
  "Bull Terrier (Standard)": "23ZOp4p9Lemi02iw0cmWCg",
  "Bulldog": "24Tt2TyxqMY2UeouMwkEKO",
  "Bulldog (American)": "5PJAsC1xjUmc2QimiAI2wC",
  "Bulldog (Standard)": "3YimlIxmkMKmiu2uWAMS4Q",
  "Bullmastiff": "140QW454UowM8I6UCkoYKE",
  "Cairn Terrier": "1Yn50GLzsMmqAM4CgIk8O2",
  "Canaan Dog": "5YDwE9kk6IQSOwumuQAKcm",
  "Cane Corso": "4DtJ1hsfAIuS6GI0cW2K6I",
  "Canadian Eskimo Dog": "5eUmE53pjGYQ6QI6SQMq4o",
  "Cardigan Welsh Corgi": "1z3qRJ9s72oiYCoqIuWu8Q",
  "Catahoula Leopard Dog": "1swRjukuRqgO4iEQo0UES2",
  "Cavalier King Charles Spaniel": "6qWRNH4PtuUWwC6IsMMqGs",
  "Cesky Terrier": "2ezyNHpd9aGIUcuwCYoOeC",
  "Chesapeake Bay Retriever": "1QpzW3IVQYgiaiSgcMu0WO",
  "Chihuahua": "45smeBj6RGoIwIWoUuQssq",
  "Chinese Crested": "56sWwrwOc0YEeuCQU4EeKI",
  "Chinese Shar-Pei": "76q9ONhvYAGESOq0m8OiYQ",
  "Chinook": "4MhwsaSv16qKcIGMuQE4s0",
  "Chow Chow": "7fMsgg4GxUSQq08iKqkKEQ",
  "Cirneco del Etna": "2taPkq5UYoOwwiaOAquOug",
  "Clumber Spaniel": "6wnunCWvZYumOSwoCYUcyq",
  "Cocker Spaniel": "5j0GFpaUiIgUQSWkgMeisy",
  "Collie": "1Jtb3GjwEwOCscMwKQyYYQ",
  "Coonhound (Black and Tan)": "5uwbAUPqXmKIsaqgi6ESiK",
  "Coton de Tulear": "4ZL5oEipJmwcMQCWWkES0k",
  "Coyote": "2H37CjB9Ze08c8WkGamkei",
  "Curly Coated Retriever": "2qaNTOOYwoOg2ea2WY6AEY",
  "Dachshund": "5Vev6lWGYwsSiw6igWg0oQ",
  "Dachshund (Miniature Shorthaired)": "6QbncgYdUWaU8OCGuk44CM",
  "Dachshund (Longhaired)": "4TAmSK3MMMMmawgyYCCis4",
  "Dachshund (Wirehaired)": "5ISZUrNw76aSu66M6Iw6so",
  "Dachshund (Shorthaired)": "58UB3UPTAQosgWgAAeqWq6",
  "Dachshund (Miniature Wirehaired)": "2TrKAsjnkQws4wUSeS8EOk",
  "Dachshund (Miniature Longhaired)": "5bs3sPWDIQMCaGGOYyQeMg",
  "Dalmatian": "1bPHZE2lDmmMOA6EEASeea",
  "Dandie Dinmont Terrier": "44aJmRTKxGKYYWSWSKImUA",
  "Dogue de Bordeaux": "4Dw3vcDuZWYekC2mKOa4Oe",
  "Dobermann Pinscher": "2th08bv0xGYKK2EiOkG6oM",
  "Dutch Shepherd Dog": "1yfkGkvbk8EqUaYmUqmCkW",
  "English Cocker Spaniel": "2pdRrndFUsOImAmwqs0WSy",
  "English Foxhound": "RhGqPjfyKWmCwGqOa0Gks",
  "English Setter": "4yBuWokbuoiWMwyWwme6w2",
  "English Springer Spaniel": "3BZizwYHPiI8OGYyEMg0m8",
  "English Toy Spaniel": "23nUNgXKI8uwiEywwYE8Ie",
  "English Toy Terrier (Black and Tan)": "2wKdAlXvqgwY8Yswi4cc0Q",
  "Entlebucher Mountain Dog": "3877dwAlJ6W24EYqMckG60",
  "Field Spaniel": "4mtsBFUyk8MEwmmYwCuyW2",
  "Finnish Lapphund": "vpafr05XgWMWuo2souie8",
  "Finnish Spitz": "UHnZmdXbuo4AaeUEgqCea",
  "Flat Coated Retriever": "1TFLgC9kAIoAUeec6ScsQE",
  "Fox Terrier (Smooth)": "60YRX58tWwoS2mW2CyCCsS",
  "Fox Terrier (Toy)": "ygTinr3Uc0606IQwWSSEa",
  "Fox Terrier (Wire)": "68xURzpTHOWoQ2M448o4Qy",
  "French Bulldog": "2sOjaERCnmM8wYSYEEmEqC",
  "German Pinscher": "57K1rQXMtqicAm6EsWKmUk",
  "German Shepherd Dog": "1U3V8nV4Dq8mqK2cSc0swm",
  "German Shorthaired Pointer": "7hwO4xM4xiqUaWeSOqWKeu",
  "German Spitz": "5OU4ZVPPSEQy6gW8SGAqQO",
  "German Wirehaired Pointer": "5xEW1mwr6wcc4uMakoqyqQ",
  "Glen of Imaal Terrier": "2tmQJeuGDugIQo0SEuqmgy",
  "Golden Retriever": "6yjOFrxveEEqCam4C4sGW4",
  "Gordon Setter": "2Ag9bF8aXqWWcCOkqQSaww",
  "Gray Wolf": "3ZKBhZAzDaIMwgyG2oWi42",
  "Great Dane": "f7S7j1JKusiO8qamiocwW",
  "Great Pyrenees": "9r5UQDINcksWMC6smqWui",
  "Greater Swiss Mountain Dog": "JASpPUdiqOkQu8OkGUcWU",
  "Greyhound": "2SelZTqxEsoyScoSOEOgeS",
  "Harrier": "3tDfNftA4UeGEkaSCwaSmq",
  "Havanese": "1TVqAxxrIkyKmkWumIaOae",
  "Hovawart": "7Ixh48GTzaIUQQoUqSUy6y",
  "Ibizan Hound": "KEVmGFp6SaUsy8i8CMUEg",
  "Icelandic Sheepdog": "4Fslcez8KIKcY6G4sCYuKs",
  "Irish Red and White Setter": "5x8MUyjelquyya4qMCIeiC",
  "Irish Setter": "3BbmCUFkiIAUkgA6uC0Cqy",
  "Irish Terrier": "rFKo96gX0kIKsmsgWQUIm",
  "Irish Water Spaniel": "ATdX15QiVqw8oy48k8KCs",
  "Irish Wolfhound": "Syxan6F5SwUIIw4Ui6ksm",
  "Italian Greyhound": "4JHsWhr624wmMQEGIUiyQO",
  "Italian Spinone": "6vH2iwcqPu4WEu8kGK06Am",
  "Japanese Chin": "3pCHHuy2nKKi6WAom6s2Ac",
  "Japanese Shiba Inu": "v9lTLR3PeSsyW6A2iE8UM",
  "Japanese Spitz": "4jKMvRohQ4oqOm6mQU4kc0",
  "Keeshond": "33jUb7cwbK8k6gWi6MS26C",
  "Kerry Blue Terrier": "5mnNZUFKRUemMuIc6siA06",
  "Komondor": "3QrED4clbOqMsS64AGMOk2",
  "Koolie": "1XGLwoPxZmgYEOQUaoo8Eo",
  "Kooikerhondje": "3uazCrIhu0IE4o8yEIAucs",
  "Korean Jindo": "QQrn4mzyKaGsCQ8ae2kW",
  "Kritikos Lagonikos": "6zpppBsZc4uScySEg0agOk",
  "Kuvasz": "2yY0L2E5mYaCkCkWko8cm4",
  "Labrador Retriever": "5qaI85odgIIuuSamGwsKye",
  "Lagotto Romagnolo": "2BJpkq2rViUa6QMgcM6gKS",
  "Lakeland Terrier": "718isAoCEEugqSO8uYa2CI",
  "Lancashire Heeler": "5CMTSjGzaoKmUOW4sg8Oa2",
  "Leonberger": "4j8pHQfiWsMyaEOswqOmsg",
  "Lhasa Apso": "2uCH4EtPVqoW8WMCgmSAuq",
  "Lowchen": "45L380jf6UogSMY8uO4Usi",
  "Magyar Agar": "60WEOOZ0EocyAI2qAAIayg",
  "Maltese": "75OWsbtKqkeGoe8kO4uawe",
  "Manchester Terrier (Toy)": "6mo1hbyC6Auk8UKYiugamO",
  "Manchester Terrier": "4FfxrzlD8IUAosgmAyUGm8",
  "Maremma Sheepdog": "49cctIUk8oGwMIG6O8Okyu",
  "Mastiff": "1okeO1CZlGAugAiKQUIgqc",
  "McNab": "6ORWv5pOfuiuUOW4q4umAS",
  "Mi-ki": "43i82mwMgwYqkUGASuUwm2",
  "Miniature American Shepherd": "1mqeWGWu36gWW6GamcIuQQ",
  "Miniature Pinscher": "4otA9nQaHYW6GoAC008yA2",
  "Mudi": "6PdEuJv90QKiOQI6UgWki6",
  "Munsterlander (Large)": "3Nis6tDJGEY0EkWCYckkY0",
  "Munsterlander (Small)": "6i376YT4gEaKIogocuukqU",
  "Murray River Curly Coated Retriever": "40zAuVhNiU2YOgimy2cuY2",
  "Neapolitan Mastiff": "6yjvkGWRwIAAECw8WwuGOS",
  "Newfoundland": "65NNOmGd1u2yqIsgmG4kiS",
  "Norfolk Terrier": "66fmDfEYLYMym4YGQgko2",
  "Norwegian Buhund": "3jkr0sNwWkEmikO2swYAyq",
  "Norwegian Elkhound": "2KT86ndjhCQ2emGSs0aMeQ",
  "Norwegian Lundehund": "3xZuP2gGnCUe8ycmwkE2au",
  "Norwich Terrier": "2MbjP2vd5m8u0gS8c6Kogm",
  "Nova Scotia Duck Tolling Retriever": "1wvvXuLp1aCeKcgS2yMkAA",
  "Old English Sheepdog": "6PlsljIyjYsmmOmsAUmIqQ",
  "Otterhound": "59EOUKvESQAAQkisG4AOi8",
  "Papillon": "70PjeKmOliUSEguqkuMMsA",
  "Parson Russell Terrier": "5EKnegpu3mSIeuSKWqi2cY",
  "Pekingese": "4xg1WR3VRYuioWCGE8kge6",
  "Pembroke Welsh Corgi": "7Ay9eU86gEemcSUOcWa2CI",
  "Pharaoh Hound": "6IiF025Rraa2MIgC2mkYwO",
  "Plott": "60jEbR5uY8AgGU4YaQqw2G",
  "Podenco Canario": "4QNdcoCQVO6USQ2ACWUauy",
  "Pointer": "7tpZjjGLWEiyoEeIGYyS4G",
  "Pointing Griffon (Wire)": "4puK4QqrZKs8yoGuw4GIMW",
  "Polish Greyhound": "1nSaTrgtiIkmAOC0o6OUCw",
  "Polish Lowland Sheepdog": "jikZcq5jKSas2CKwsWiMW",
  "Pomeranian": "2jTtjZxnbGIcAYuYyqymsu",
  "Poodle": "3mfCT4SjwQugmy8GcSkyCo",
  "Poodle (Medium)": "56dzkHoSa4KOUy6oaQg2yK",
  "Poodle (Miniature)": "hQC92eLjVuakqaK6uqgsK",
  "Poodle (Standard)": "5iuStNczzqqUgwSA8qGyQs",
  "Poodle (Toy)": "3JftLswCd26wMgOqky4ISq",
  "Portuguese Podengo Medio": "4b5yuyuGV2e02Yqa2yuW8e",
  "Portuguese Podengo Pequenos": "mQWdEzOhfUIsiec8eUQyi",
  "Portuguese Water Dog": "33VvIoNfWgwIEES6w6q2sS",
  "Presa Canario": "62LJyY7kuQs0cYAw2gEYwC",
  "Pug": "6Gk0w42dkA6eGmSG4KYmOA",
  "Puli": "6aTFaEmYMMwq4Owas0cqCo",
  "Pumi": "4kEnS0J6RyaEiGSggA44QG",
  "Pyrenean Shepherd": "4ikWnFRJQI00m2CcqaOkO",
  "Rat Terrier": "3BCzLV9KoUeyuE4SO8sQeG",
  "Redbone Coonhound": "1pbphwZPhOAS4C28e2W42S",
  "Rhodesian Ridgeback": "2WK0FCoDFCyG6qIOyMOaa8",
  "Rottweiler": "3GRNBl1t1C4yqio0AWocO4",
  "Russian Tsvetnaya Bolonka": "5bu1vzDVXaoyGs8IAS6GWo",
  "Russell Terrier": "7IfvQxuZJ6WuossCKoS86y",
  "Saint Bernard": "6noPg01MpUSWiqq0WiQO0g",
  "Saluki": "4DumoeHXBeKsGe4ymwS0YO",
  "Samoyed": "6CzfJVotSE2QQ226k2gqKY",
  "Schipperke": "2awxWYKEbeieECm0WyaSsO",
  "Schnauzer (Giant)": "1jJUcI6m5A4w6eGqguWykE",
  "Schnauzer (Miniature)": "1CXtgbTH9e2k4g8Qysswqm",
  "Schnauzer (Standard)": "2WGyp1d1mMo4k6SsCEAscM",
  "Scottish Deerhound": "6GyxBvry8gO80U24i4QkAK",
  "Scottish Terrier": "6yP2wUL7xuOu22UEaSKoIq",
  "Sealyham Terrier": "4DYnCtouqI0caUw24wKiOI",
  "Shetland Sheepdog": "3civWHLOmQgwowUEk44YMw",
  "Shih Tzu": "1FNyNfNmiA26WEkkAcSKay",
  "Siberian Husky": "4GlgNd0EWIg8ocQgKAggO6",
  "Silky Terrier": "3PcTxecUdq4iaWyEGU0ass",
  "Skye Terrier": "2d7RxqdkyQMOCwMIKyyCqW",
  "Sloughi": "4irJvjR8CccwiMsis6U6AI",
  "Soft Coated Wheaten Terrier": "20FUcsUkugaASgwKq8E4OK",
  "Spanish Greyhound": "4UPHAcuypOQ086W2A0KyAK",
  "Spanish Water Dog": "3jzbLFa6pW0yAGcE2wO2A2",
  "Staffordshire Bull Terrier": "2VdaTPnMgUC4m8qMk6UiOm",
  "Sussex Spaniel": "2v8ih3tkJ66EuGOk8MYI0Y",
  "Swedish Vallhund": "7wY10c5EJimQGMi8Uu0Ima",
  "Taigan": "5YijL3sMVisWAeucO6m6gI",
  "Tibetan Mastiff": "2VOv0HFKsEs8CkcUs0WAUy",
  "Tibetan Spaniel": "6kIxSCwRgca8E0Kkuc02Uu",
  "Tibetan Terrier": "4oGrl7kJqwwwqYk6mQisIO",
  "Treeing Walker Coonhound": "2ka8FZSCTKMy4wm8SUUWoc",
  "Vizsla": "6kurbAoCAgOgwUKckGgOis",
  "Weimaraner": "2NZduNuFtueO0AaAosK0mE",
  "Welsh Springer Spaniel": "5KNRq0lYpUIkU02S6EqIwo",
  "Welsh Terrier": "3snSlE7yPCqaoKoQEqSi0C",
  "West Highland White Terrier": "l0y8sHlZmKs4SyaqkqiI6",
  "Whippet": "39wsB0xkTSyggiUgOcUwuW",
  "White Swiss Shepherd": "57rDvS5Oicc2gI2u2kKwGq",
  "Wirehaired Vizsla": "4iUFdMCZ7iigEOK4uk2UYs",
  "Xoloitzcuintli": "47U4hMPAbuU4EkOQ4IAIWY",
  "Yorkshire Terrier": "2CxvDMyr3qwOa8kKSQCyoY"
}



// WEBPACK FOOTER //
// ./client/apps/dnareport/services/entryid/entries.js